import * as React from 'react';
import type { CompRef, CompStructure } from '@wix/document-services-types';

export enum QuickEditControlActions {
  LINK = 'link',
  SETTINGS = 'settings',
  BACKGROUND = 'background',
  CHANGE_MEDIA = 'change_media',
  MANAGE = 'manage',
  DRILL_IN = 'drill_in',
  CUSTOM = 'custom',
}

export interface QuickEditControlActionOptions {
  shouldPerformActionOnStage?: boolean;
}

export type QuickEditControl = React.FC<QuickEditControlOwnProps>;

export interface QuickEditControlEntry {
  getControl: () => QuickEditControl;
}

export interface QuickEditControlWrapperOwnProps {
  compRef: CompRef;
  rootControlCompRef: CompRef;
  shouldRenderDivider: boolean;
  hasListAncestor: boolean;
}

export interface QuickEditControlOwnProps {
  compRef: CompRef;
  onHelp: () => void;
  monitorValueChanges: (value: any) => void;
  isSelected: boolean;
  displayName: string;
  hasPrimaryConnection: boolean;
  isConnectedToDataBinding: boolean;
  mainActionLabel: string;
  onMainActionClick: (options?: QuickEditControlActionOptions) => void;
  onSecondaryActionClick?: () => void;
  secondaryActionLabel?: string;
  onActionClick: (
    action: QuickEditControlActions,
    options?: QuickEditControlActionOptions,
  ) => void;
  setIsSelected: (action?: QuickEditControlActions) => void;
  translate: (key: string, options?: Record<string, string>) => string;
  onMouseOver?: (compRef: CompRef) => void;
  onMouseLeave?: () => void;
  children?: React.ReactElement;
  configuration: {
    permissions: {
      tooltipHidden?: boolean;
      buttonHidden?: boolean;
      buttonDisabled?: boolean;
    };
  };
  getThumbnail?: (
    compDef: CompStructure,
    thumbnailDimensions: { width: number; height: number },
    onReady?: () => void,
  ) => Promise<React.ReactElement>;
  hasListAncestor: boolean;
  mapCompTypeToDrillInPanel?: { [compType: string]: React.FC };
  isMainComponent?: boolean;
}
